<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <h3>{{ pageTitle }}</h3>
      <hr>
      
      <AppForm
        v-show="pageShowData"
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-input="onFormInput" >

        <div
          slot="jt-form-slot-sectionProductSubscriptionLease">
          <PagePLReinstatementFormLease
            ref="pageTableLease" />
        </div>

        <div
          slot="jt-form-slot-sectionReinstatementSummary"
          class="col-12 table-responsive">
          <table class="table table-bordered">
            <tr>
              <th>Status</th>
              <th>Parking Product</th>
              <th>Deposit (RM)</th>
              <th>Parking Fee (RM)</th>
            </tr>
            <tr 
              v-show="pageSeasonChanged && pageSeasonChanged.length > 0"
              v-for="(pageSeason, pageSeasonIndex) in pageSeasonChanged"
              v-bind:key="pageSeasonIndex">
              <td>{{ pageSeason['status'] }}</td>
              <td>{{ pageSeason['product'] }}</td>
              <td>{{ pageSeason['deposit'] }}</td>
              <td>{{ pageSeason['parkingFees'] }}</td>
            </tr>
          </table>
        </div>
        
      </AppForm>

      <TemplateFeedback ref="pageFeedback" />

      <TemplateFeedback ref="warning" />

      <button v-show="pageShowData" v-on:click="onCancelButtonClick" type="button" class="btn btn-default">
        Cancel
      </button>

      <TemplateButton v-show="hasAddPermission() && pageShowAdd && pageCanAdd" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Proceed Reinstatement Payment
      </TemplateButton>

      <TemplateButton v-show="hasEditPermission() && pageShowEdit && pageCanEdit" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Submit Application
      </TemplateButton>

      <div class="btn-group" v-show="(hasApprovePermission() || hasRejectPermission() || hasVoidPermission()) && approvalShow">
        <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Approval Action
        </button>
        <div class="dropdown-menu">
          <a v-show="hasApprovePermission() && approvalShowApprove" class="dropdown-item" href="#" v-on:click.prevent="onApplicationApproveClick" >Approve Application</a>
          <a v-show="hasRejectPermission() && approvalShowReject" class="dropdown-item" href="#" v-on:click.prevent="onApplicationRejectClick" >Reject Application</a>
          <a v-show="hasVoidPermission() && approvalShowVoid" class="dropdown-item" href="#" v-on:click.prevent="onApplicationVoidClick" >VOID Application</a>
        </div>
      </div>

      <TemplateButton v-show="approvalShowComplete" v-on:click="onCompleteButtonClick" type="button" class="btn btn-danger">
        Complete
      </TemplateButton>

      <TemplateButton v-show="approvalShowReachTerminationEffective" v-on:click="onTerminationEffectiveButtonClick" type="button" class="btn btn-danger">
        Reach Termination Effective Date
      </TemplateButton>
      
      <AppModalForm 
        ref="pageApprovalModal" 
        v-bind:formParameter="[]"
        v-bind:modalShowDelete="false"
        v-bind:modalShowEdit="false"
        v-bind:modalShowAdd="false">
        <div>
          {{ approvalText }}
        </div>
        <div v-show="approvalReject">
          <br>
          <label>Reason of Reject</label>
          <input class="form-control" v-model="approvalRejectReason">
          <label class="error form-control-feedback">{{approvalRejectReasonError}}</label>
        </div>
        <TemplateButton slot="modal-footer-after" @click="pageApprovalModalConfirm" type="button" class="btn btn-success">
          Confirm
        </TemplateButton>
      </AppModalForm>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import PagePLReinstatementFormLease from "@/components/Page/ParkingLicense/PagePLReinstatementFormLease";

var querystring = require('querystring');
var moment = require('moment');

let commencementDateValidate = function(date) {
  return true;
}

const PARAM = [
  {
    key: 'carparkID',
    text: 'Car Park',
    form_select: {
      data: [],
      formatSelectOptionValue: (data) => data.id, 
      formatSelectOptionText: (data) => data.carparkCode ? `${data.carparkCode} - ${data.name}` : data.name,
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'licenseID',
    text: 'Parking License',
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
        let customer = option['_customer'];
        text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
        return text;
      },
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'sectionProductSubscription',
    form_section: 'Product Subscription',
  },
  {
    key: '_lease',
    form_label_attr: { style: 'display:none'},
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        if(typeof option === 'string') {
          return option;
        }
        let text = `${option['leaseZone']} - ${option['leaseProductName']} - ${option['parkerName']} `;
        if(option['isParkAide']) {
          text += '(Passcard: ParkAide Blocked)';
          if(new moment() > helper.parseDateTime(option['commencementDate'])) {
            if(!option['isBlock']) {
              text += '(Passcard: ParkAide Active)';
            }
          }
        } else {
          text += option['leasePasscard'] ? '(Passcard: ' + option['leasePasscard'] + ')' : '';
        }
        return text;
      },
    },
    form_edit_hide: true,
    form_chosen: true,
    form_input_validation: [],
    // form_input_attr: { 'multiple' : true },
    // form_chosen_multiple: true,
  },
  {
    key: 'sectionProductSubscriptionLease',
    form_html: () => '',
  },
  {
    key: 'applicationStaff',
    text: 'Staff Name',
    form_select: [],
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'applicationStaffNo',
    text: 'Staff No',
    form_input_attr: {
      disabled: true,
    },
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PagePLReinstatementForm",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    AppForm,
    AppModalForm,
    PagePLReinstatementFormLease,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
        { name: 'Reinstatement Application', url: '/plReinstatement' },
      ],

      API_PATH: "/api2/application/",
      PARAM,
      PARAM_MAP,

      pageTitle: null,
      pageShowData: false,
      pageShowAdd: false,
      pageCanAdd: false,
      pageShowEdit: false,
      pageCanEdit: false,

      pageSeasonChanged: [],

      pageTenant: null,
      pageStaff: null,
      pageCarpark: null,
      pageCustomer: null,
      pagePasscard: null,

      pageLicense: null,
      pageSeason: undefined,
      pageFees: {},
      pageParker: undefined,

      approvalShow: false,
      approvalShowApprove: false,
      approvalShowReject: false,
      approvalShowVoid: false,
      approvalShowComplete: false,
      approvalShowReachTerminationEffective: false,

      approvalText: null,
      approvalReject: false,
      approvalRejectReason: null,
      approvalRejectReasonError: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$nextTick(() => {
      helper.setSidebar('/plReinstatement');
    });
    
    this.hideFormFromKey('licenseID');
    this.loadTenant();
  },
  methods: {
    hideFormFromKey(key) {
      this.pageShowAdd = false;
      this.pageShowEdit = false;

      if(key === null) {
        this.pageShowAdd = true;
        this.pageShowEdit = true;
      }

      let hide = false;
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        parameter.form_hide = hide;
      });
    },

    // 1. load staff, customer & carpark
    // 2a. if add - init application, load license, license lease
    // 2b. if edit - load application, license (specific, for customer + carpark), application data, application lease
    // 3. load leases related (parker, season, season fees)
    loadTenant() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading tenant data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/tenant',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageTenant = response.data;
          this.loadEntitlement();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'tenant data'));
        });
    },
    loadEntitlement() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading entitlement data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/entitlement',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageEntitlement = response.data;
          this.loadStaff();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'entitlement data'));
        });
    },
    loadStaff() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading staff data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/personnel/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['applicationStaff'], response.data);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'staff data'));
        });
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          // helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark = response.data);
          // this.loadZone();

          this.pageCarpark = response.data
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park zone data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadApplication();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park zone data'));
        });
    },

    loadApplication() {
      let applicationID = this.$route.query.applicationID;
      if(applicationID) {
        let feedbackItem = 'parking license reinstatement application info';
        this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
        this.$http
          .get(
            helper.SERVER_URL + '/api2/request?carparkID=' + this.$route.query.carparkID + '&applicationID=' + applicationID + '&type1=Reinstatement',
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            response.data = response.data.filter(k => k.createDate > 1545955200);

            let temp = response.data[0];
            let application = {};
            application['applicationID'] = temp['applicationID'];
            application['licenseID'] = temp['licenseID'];
            application['carparkID'] = temp['carparkID'];
            application['customerID'] = temp['customerID'];
            application['applicationStaff'] = temp['data1'];
            application['status'] = temp['status1'];
            application['lease'] = response.data;
            this.$refs['pageForm'].setForm(false, application);
            this.$refs['pageTableLease'].setLeaseData(application['lease'] = response.data, false);

            if(application['status'] === 'Pending Approval' || application['status'] === 'Pending') {
              this.approvalShow = true;
              this.approvalShowApprove = true;
              this.approvalShowReject = true;
              this.approvalShowVoid = true;
              this.pageCanEdit = true;
            } else if(application['status'] === 'Approved') {
              this.approvalShow = false;
              this.approvalShowApprove = false;
              this.approvalShowReject = false;
              this.approvalShowVoid = false;
              this.approvalShowComplete = true;
              this.approvalShowReachTerminationEffective = false;
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            } else if(application['status'] === 'Completed') {
              this.approvalShow = false;
              this.approvalShowApprove = false;
              this.approvalShowReject = false;
              this.approvalShowVoid = false;
              this.approvalShowComplete = false;
              this.approvalShowReachTerminationEffective = true;
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            } else {
              this.approvalShow = false;
              this.approvalShowApprove = false;
              this.approvalShowReject = false;
              this.approvalShowVoid = false
              this.approvalShowComplete = false;
              this.approvalShowReachTerminationEffective = false;
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            }
            
            this.onApplicationStaffChange();

            this.pageTitle = 'Parking License Reinstatement Application ' + (this.pageApplication = helper.plFormPLREINum(application['applicationID'], application['carparkID']));
            this.pageShowData = true;

            this.loadLicense();
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          })
      } else {
        this.pageCanAdd = true;
        let tempData = this.$refs['pageForm'].getFormDefaultData();
        tempData.lease = [{}];
        tempData['carparkID'] = this.$route.query.carparkID || tempData['carparkID'];
        tempData['licenseID'] = this.$route.query.licenseID || tempData['licenseID'];
        tempData['_commencementDate'] = helper.formatDate(moment().endOf('month').add('day', 1).add('month', 1).startOf('day'));

        this.pageTitle = 'Parking License Reinstatement Application';
        this.pageShowData = true;
        this.$refs['pageForm'].setForm(true, tempData);

        if(this.$refs['pageForm'].formData['carparkID']) {
          this.loadLicense();
        }
      }
    },

    loadLicense() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL;
      if(!this.$refs['pageForm'].formIsAdd) {
        url += '/api2/license/' + formData['licenseID'];
      } else {
        url += '/api2/carpark/' + formData['carparkID'] + '/license/';
      }
      
      let feedbackItem = 'parking license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          // TODO kw1 only show active license & lease
          if(this.$refs['pageForm'].formIsAdd) {
            response.data = response.data.filter(k => k.status === 'Active');
          }
          this.pageLicense = response.data;

          response.data.forEach(k => {
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
          });

          helper.inputSelectSetOption(this.PARAM_MAP['licenseID'], response.data);
          this.hideFormFromKey('sectionProductSubscription');

          if(!this.$refs['pageForm'].formIsAdd) {
            formData['carparkID'] = response.data.find(k => helper.compareID(k.id, formData['licenseID']))['carparkID'];
            this.$refs['pageForm'].$forceUpdate();
            // this.loadApplicationData(formData['applicationData']);

            this.$refs['pageForm'].formData['lease'].forEach(k => k['leaseSelected'] = true);
            this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData['lease'], false);
            this.loadLicenseLease();
            return;
          }

          if(formData['licenseID'] && response.data.find(k => helper.compareID(k.id, formData['licenseID']))) {
            this.loadLicenseLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackMessage();
            formData['licenseID'] = null;
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicenseLease() {
      this.hideFormFromKey('sectionProductSubscription');

      this.pageSeason = null;
      this.pageParker = null;

      let feedbackItem = 'parking license lease data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license/' + this.$refs['pageForm'].formData['licenseID'] + '/lease/?current=1',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          if(!this.$refs['pageForm'].formIsAdd) {
            this.pageLicenseLease = response.data;
            this.loadPasscard();
            return;
          }

          if(this.$refs['pageForm'].formIsAdd) {
            response.data = response.data.filter(k => k.status === 'Pending Termination' && !k.reason.includes('Returned'));
          }

          if(response.data.length === 0) {
            this.$refs['pageFeedback'].setFeedbackError('No active subscription available');
            return;
          }

          this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData['lease'] = response.data, true);
          this.loadPasscard();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadPasscard() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL + '/api2/carpark/' + formData['carparkID'] + '/passcard/';

      let feedbackItem = 'parking license passcard'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          // this.loadLeaseData();
          this.loadTerminationApplication();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    async loadTerminationApplication() {
      let feedbackItem = 'lease data';
      let formData = this.$refs['pageForm'].formData;
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let licenseLease = await this.$http
        .get(
          helper.SERVER_URL + '/api2/license/' + formData['licenseID'] + '/lease',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })

      let url = helper.SERVER_URL + '/api2';
      url += '/request/?type1=termination&licenseID=' + formData['licenseID'];
      // url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.pageTermination = response.data;
          this.pageTermination.sort((a,b) => b.createDate - a.createDate);

          this.$refs['pageForm'].formData['lease'].forEach(k => {
            k['_termination'] = this.pageTermination.find(j => {
              return j['leaseID'] === (k['leaseID'] || k['id']);
            }) || {};
          });

          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadLeaseData() {
      if(!this.pageCarparkSeason) {
        this.loadCarparkSeasonSetting();
        return;
      }

      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      helper.inputSelectSetOption(this.PARAM_MAP['_lease'], this.$refs['pageForm'].formData['lease']);

      this.calculateParkingFees();
    },
    loadCarparkSeasonSetting() {
      let carparkID = this.$refs['pageForm'].formData['carparkID'];
      if(!carparkID) {
        return;
      }

      let feedbackItem = 'car park season setting';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + carparkID + '/seasonSetting/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCarparkSeason = response.data[0];

          if(!this.pageCarparkSeason) {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
            return;
          }

          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadSeason() {
      this.hideFormFromKey('sectionProductSubscription');

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['pageForm'].formData['carparkID'] + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.pageSeason.forEach(k => {
              k['_zone'] = this.pageZone.find(j => helper.compareID(j.id, k.zoneID));
            })
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.hideFormFromKey('sectionReinstatementSummary');

      this.pageFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            // if(this.pageFees[seasonID] = response.data[0]) {
            // if(this.pageFees[seasonID] = response.data.find(k => k.isActive)) {
            if(this.pageFees[seasonID] = response.data) {
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.calculateParkingFees();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      this.hideFormFromKey('sectionProductSubscription');

      let customerID = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], this.$refs['pageForm'].formData['licenseID']).customerID;

      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + customerID + '/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageParker = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    isTenant() {
      let formData = this.$refs['pageForm'].formData;
      let customerID = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], formData['licenseID']).customerID;
      return formData['tenant'] = this.pageTenant.find(k => helper.compareID(k.carparkID, formData['carparkID']) && helper.compareID(k.customerID, customerID));
    },

    calculateParkingFees() {
      let formData = this.$refs['pageForm'].formData;
      formData.lease = formData.lease || [];
      formData['applicationTotalPayable'] = 0.00;
      formData.lease.forEach(leaseData => {
        this.$refs['pageTableLease'].removeLeaseDataSeasonField(leaseData);
      });
      this.$refs['pageTableLease'].setLeaseTotal();

      if(this.checkSeasonFees()) {
        return;
      }

      let leaseTotal = {};
      this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => leaseTotal[k] = 0);

      let tandemCalculated = [];
      formData.lease.forEach(leaseData => {
        if(!this.$refs['pageForm'].formIsAdd) {
          let originalLease = this.pageLicenseLease.find(k => helper.compareID(k.id, leaseData['leaseID']));
          if(originalLease) {
            leaseData['status'] = originalLease['status'];
            leaseData['reason'] = originalLease['reason'];
            leaseData['passcardID'] = originalLease['passcardID'];
            leaseData['leaseSubscriptionStatus'] = originalLease['status'];
          }
        }

        if(leaseData['isParkAide']) {
          leaseData['leasePasscard'] = 'N/A';
          leaseData['leasePasscardStatus'] = 'ParkAide Blocked';
          if(leaseData['status'] === 'Active' || leaseData['status'] === 'Pending Termination') {
            if(new moment() > helper.parseDateTime(leaseData['commencementDate'])) {
              if(!leaseData['isBlock']) {
                leaseData['leasePasscardStatus'] = 'ParkAide Active';
              }
            }
          }
          leaseData['leaseIsParkAide'] = 'Yes';
        } else {
          let passcard = this.pagePasscard.find(k => helper.compareID(k.id, leaseData['passcardID']));
          if(passcard) {
            leaseData['leasePasscard'] = passcard.sku;
            leaseData['leasePasscardStatus'] = 'Passcard Issued';
            leaseData['leaseIsParkAide'] = 'No';
            leaseData['_passcard'] = passcard;
          } else {
            leaseData['leasePasscard'] = 'N/A';
            leaseData['leasePasscardStatus'] = 'N/A';
            leaseData['leaseIsParkAide'] = 'No';
          }
        }

        // leaseData['leaseTermination'] = helper.plFormPLTNum(leaseData['_termination']['applicationID'], leaseData['carparkID'])
        leaseData['leaseTerminationApplicationID'] = leaseData['_termination']['applicationID'];
        leaseData['leaseTerminationDate'] = helper.formatDate(leaseData['_termination']['date1']);
        leaseData['leaseReinstatementFees'] = helper.formatMoney(leaseData['data2'] || this.pageCarparkSeason['Reinstatement']);

        let applicationPaymentPlan = parseInt(leaseData['paymentPlan']);
        if(applicationPaymentPlan === undefined || applicationPaymentPlan === null) {
          return;
        }

        let applicationCommencementDateText = leaseData['commencementDate'];
        if(applicationCommencementDateText === undefined || applicationCommencementDateText === null) {
          return;
        }

        let applicationCommencementDate = helper.parseDateTime(applicationCommencementDateText);
        let daysInMonth = applicationCommencementDate.daysInMonth();
        let startDay = applicationCommencementDate.date();

        if(leaseData['parkerID']) {
          let parker = this.pageParker.find(k => k['id'] === leaseData['parkerID'])
          leaseData['_parker'] = parker;
          leaseData['parkerName'] = parker['name'];
          this.$refs['pageTableLease'].setLeaseDataParker(leaseData, parker);
        } else {
          let parker = this.pageParker.find(k => k['id'] === leaseData['parkerID'])
          leaseData['_parker'] = parker;
          leaseData['parkerName'] = parker['name'];
          this.$refs['pageTableLease'].setLeaseDataParker(leaseData, parker);
        }
        
        let season = this.pageSeason.find(k => helper.compareID(k.id, leaseData['seasonID'])) || {};
        leaseData['leaseProductName'] = season.name;

        let zone = this.pageZone.find(k => helper.compareID(k.id, (season || {})['zoneID'])) || {};
        leaseData['leaseZone'] = zone.name;
        
        let product = this.pageFees[leaseData['seasonID']].find(k => helper.compareID(k.id, leaseData['seasonFees']));
        // if(!product || product.startDate > leaseData['commencementDate']) {
        if(!product) {
          product = this.pageFees[leaseData['seasonID']].find(k => k.isActive)
          if(!product) {
            for(let temp of this.pageFees[leaseData['seasonID']]) {
              if(temp.startDate <= leaseData['commencementDate']) {
                product = temp;
                break;
              }
            }
          }
        }
        if(!product) return;
        leaseData['seasonFeesID'] = product.id;

        if(!leaseData.leaseSelected) {
          return;
        }

        product.feesDeposit = parseFloat(product['deposit'] || 0);
        product.feesEstablishment = parseFloat(product['establishment'] || 0);
        product.fees1Month = parseFloat(product['monthly'] || 0);
        product.fees3Month = parseFloat(product['quarterly'] || 0) * 3;
        product.fees6Month = parseFloat(product['halfYearly'] || 0) * 6;
        product.fees12Month = parseFloat(product['annually'] || 0) * 12;
        
        leaseData['commencementDate'] = applicationCommencementDate.unix();
        leaseData['commencementDateText'] = helper.formatDate(leaseData['commencementDate']);
        leaseData['paymentPlan'] = applicationPaymentPlan;

        leaseData['leaseProductDeposit'] = product.feesDeposit;
        leaseData['leaseProductDepositText'] = helper.formatMoney(leaseData['leaseProductDeposit']);
        leaseData['leaseProductEstbFee'] = product.feesEstablishment;

        switch(applicationPaymentPlan) {
          case 1:
            leaseData['paymentPlanText'] = 'Monthly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees1Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
            }
            leaseData['leaseProductParkingFee'] = product.fees1Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / month';
            break;
          case 2:
            leaseData['paymentPlanText'] = 'Quarterly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees3Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees3Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees3Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / quarter';
            break;
          case 3:
            leaseData['paymentPlanText'] = 'Half-yearly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees6Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees6Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees6Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / half-year';
            break;
          case 4:
            leaseData['paymentPlanText'] = 'Annually';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees12Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees12Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees12Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / annual';
            break;
        }

        leaseData['leaseProductInitialPayment'] = product.feesDeposit + product.feesEstablishment + leaseData['leaseProductInitialParkingFee'];

        this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => {
          if(!leaseData['pairID'] || !tandemCalculated.includes(leaseData['pairID'])) {
            leaseTotal[k] += leaseData[k];
          }
          leaseData[k + 'Text'] = leaseData[k + 'Text'] || helper.formatMoney(leaseData[k]);
        });
        tandemCalculated.push(leaseData['pairID']);
      });
      this.$refs['pageForm'].$refs['jt-form-element-_lease'][0].$forceUpdate();

      this.$refs['pageTableLease'].setLeaseTotal(leaseTotal);
      formData['applicationTotalPayable'] = leaseTotal['leaseProductInitialPaymentText'];
    },
    checkSeasonFees() {
      let formData = this.$refs['pageForm'].formData;
      for(let leaseData of formData.lease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          // load season fees
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },

    onCancelButtonClick() {
      let url = this.$route.query.pending ? helper.WEB_URL + '/plReinstatementPending' : helper.WEB_URL + '/plReinstatement';
      helper.redirect({ path: url, query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },
    onSaveButtonClick() {
      if(!this.$refs['pageForm'].validateForm() && !this.validateApplicationData()) {
        if(this.$refs['pageForm'].formIsAdd) {
          this.addApplication({});
        } else {
          this.editApplication({});
        }
      }
    },
    validateApplicationData() {
      let formData = this.$refs['pageForm'].formData;
      let hasSelected = false;
      if(!formData.lease.find(k => k.leaseSelected)) {
        this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError('Please select at least one subscription to proceed');
        $(document).scrollTop($('#jt-form-div-sectionProductSubscription')[0].offsetTop);
        return true;
      }

      // TODO kw1 validate whatever special reinstatement field
    },
    
    addApplication(data) {
      let formData = this.$refs['pageForm'].formData;
      
      let temp = {}
      temp['carparkID'] = formData['carparkID'];
      temp['applicationStaff'] = formData['applicationStaff'];
      temp['operatorID'] = this.pageCarpark.find(k => helper.compareID(k.id, formData['carparkID'])).operatorID;
      temp['leases'] = JSON.stringify(formData['lease'].filter(k => k.leaseSelected));

      let feedbackItem = 'parking license reinstatement application';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseReinstatement/create',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    editApplication(data) {
      let formData = this.$refs['pageForm'].formData;

      let temp = {}
      temp['commencementDate'] = helper.parseDateTime(formData['_commencementDate']).unix();
      temp['seasonFeesID'] = formData['seasonFeesID'];
      temp['applicationStaff'] = formData['applicationStaff'];
      temp['leases'] = JSON.stringify(formData['lease'].filter(k => k.leaseSelected));

      let feedbackItem = 'parking license reinstatement application';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .put(
          helper.API_URL + '/api2/licenseReinstatement/update',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      let url = this.$route.query.pending ? helper.WEB_URL + '/plReinstatementPending' : helper.WEB_URL + '/plReinstatement';
      helper.redirect({ path: url, query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },
    
    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'carparkID') {
        this.pageCarparkSeason = null;
        formData['licenseID'] = null;
        formData['_lease'] = [];
        formData['lease'] = [];
        this.loadLicense();
      } else if(formParameter.key === 'licenseID') {
        formData['_lease'] = [];
        formData['lease'] = [];
        formData['customerID'] = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], formData['licenseID']).customerID;
        this.loadLicenseLease();
      } else if(formParameter.key === '_lease') {
        formData['lease'].forEach(k => {
          if(formData['_lease'].includes('All Subscription')) {
            k.leaseSelected = true;
          } else {
            k.leaseSelected = formData['_lease'].includes('' + k.id);
          }
        });
        this.calculateParkingFees();
        this.$refs['pageTableLease'].$forceUpdate();
        this.hideFormFromKey(null);
      } else if(formParameter.key === 'applicationStaff') {
        this.onApplicationStaffChange();
      }
    },
    onApplicationStaffChange() {
      let staff = helper.inputSelectFindOption(this.PARAM_MAP['applicationStaff'], this.$refs['pageForm'].formData['applicationStaff']) || {}
      this.$refs['pageForm'].formData['applicationStaffNo'] = staff['personnelCode'];
    },

    onApplicationApproveClick() {
      this.approvalAction = 'approve';
      this.approvalText = 'Approve parking license reinstatement application ' + this.pageApplication;
      this.approvalReject = false;
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Approve Application');
    },
    onApplicationRejectClick() {
      this.approvalAction = 'reject';
      this.approvalText = 'Reject parking license reinstatement application ' + this.pageApplication;
      this.approvalReject = true;
      this.approvalRejectReason = '';
      this.approvalRejectReasonError = '';
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Reject Application');
    },
    onApplicationVoidClick() {
      this.approvalAction = 'void';
      this.approvalText = 'VOID parking license reinstatement application ' + this.pageApplication;
      this.approvalReject = false;
      this.$refs['pageApprovalModal'].setModalOpen(false, 'VOID Application');
    },
    onCompleteButtonClick() {
      this.updateApplicationStatus('complete');
    },
    onTerminationEffectiveButtonClick() {
      this.updateApplicationStatus('reachTerminationEffective');
    },
    pageApprovalModalConfirm() {
      if(this.approvalAction === 'reject') {
        if(!this.approvalRejectReason) {
          this.approvalRejectReasonError = 'Reason of Reject cannot be empty';
          return;
        } else {
          this.approvalRejectReasonError = '';
        }
      }

      this.updateApplicationStatus(this.approvalAction);
    },
    updateApplicationStatus(action) {
      this.$refs['pageApprovalModal'].setModalClose('');

      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = 'parking license reinstatement application ' + this.pageApplication + ' status';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseReinstatement/' + action,
          querystring.stringify({ leases: JSON.stringify(formData['lease']), rejectReason: this.approvalRejectReason }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },

    hasAddOrEditPermission() {
      return this.pageIsAdd ? helper.hasAddPermission(this.permission) : helper.hasEditPermission(this.permission);
    },
    hasAddPermission() {
      return helper.hasAddPermission(this.permission);
    },
    hasEditPermission() {
      return helper.hasEditPermission(this.permission);
    },
    hasApprovePermission() {
      return helper.hasPermission(this.permission + '.approve', false);
    },
    hasRejectPermission() {
      return helper.hasPermission(this.permission + '.reject', false);
    },
    hasVoidPermission() {
      return helper.hasPermission(this.permission + '.void', false);
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLReinstatementForm.vue